import { commonAPI } from '@redux/api/common.api'

type MobileConfigVersion = {
  id?: string
  versionId?: string
  code?: string
  [key: string]: any
}

export const mobileConfigApi = commonAPI.injectEndpoints({
  endpoints: build => ({
    applyCurrentMobileConfig: build.mutation<void, void>({
      query: () => ({
        url: '/api/mobile-cfg/config/apply-current',
        method: 'POST',
      }),
    }),
    resetMobileConfigToBase: build.mutation<void, void>({
      query: () => ({
        url: '/api/mobile-cfg/config/reset-to-base',
        method: 'POST',
      }),
    }),
    fetchMobileConfigVersions: build.query<MobileConfigVersion[], void>({
      query: () => ({
        url: '/api/mobile-cfg/cfg/system/list',
      }),
    }),
    applyMobileConfigVersion: build.mutation<void, { code: string }>({
      query: ({ code }) => ({
        url: `/api/mobile-cfg/config/apply/${encodeURIComponent(code)}`,
        method: 'POST',
      }),
    }),
  }),
})

export const {
  useApplyCurrentMobileConfigMutation,
  useResetMobileConfigToBaseMutation,
  useLazyFetchMobileConfigVersionsQuery,
  useApplyMobileConfigVersionMutation,
} = mobileConfigApi
